import { ExternalLink, Quote } from "lucide-react";
import { Reveal, Kicker } from "./shared";

const REVIEWS = [
  {
    quote: "Vysoce kvalitní, precizně postavená pražička, kterou ovládáte aplikací — z telefonu, tabletu, nebo přes Artisan.",
    author: "Virtual Coffee Lab",
    detail: "24,7 tis. odběratelů · YouTube",
    link: "https://www.youtube.com/watch?v=WeiAHmYtLWA",
    linkLabel: "Unboxing & Full Auto Roast",
  },
  {
    quote: "Pokud jste kdy snili o pražení vlastní kávy doma s minimem starostí, BeanGo Cube X Pro může být konečně ten správný přístroj.",
    author: "The Basic Barista",
    detail: "15,6 tis. odběratelů · YouTube",
    link: null,
    linkLabel: null,
  },
  {
    quote: "Malý. Výkonný. Mění pravidla hry. Tato kostkovitá pražička vám umožní pražit vlastní zrna kdekoliv a kdykoliv.",
    author: "Mitch Does Coffee",
    detail: "4,9 tis. odběratelů · YouTube",
    link: "https://www.youtube.com/watch?v=zk40qXz9hOc",
    linkLabel: "BeanGo Cube X Pro — recenze",
  },
];

export default function Reviews() {
  return (
    <section id="recenze" className="relative border-t border-stone-200 bg-white py-24 sm:py-32" data-testid="reviews-section">
      <div className="mx-auto max-w-7xl px-6">
        <Reveal>
          <Kicker>Recenze</Kicker>
          <h2 className="mt-3 max-w-2xl font-display text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl md:text-5xl">
            Recenze mluví za vše
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.author} delay={i * 0.1}>
              <blockquote className="flex h-full flex-col rounded-lg border border-stone-200 bg-[#FAF7F2] p-8 transition-colors duration-500 hover:border-gold/50" data-testid={`review-card-${i}`}>
                <Quote className="h-6 w-6 text-gold" aria-hidden="true" />
                <p className="mt-6 flex-1 text-base leading-relaxed text-stone-700">„{r.quote}"</p>
                <footer className="mt-8 border-t border-stone-200 pt-5">
                  <p className="font-display text-sm font-bold text-stone-900">{r.author}</p>
                  <p className="mt-1 text-xs text-stone-500">{r.detail}</p>
                  {r.link && (
                    <a
                      href={r.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-3 inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-gold transition-colors duration-300 hover:text-gold-light"
                      data-testid={`review-link-${i}`}
                    >
                      {r.linkLabel}
                      <ExternalLink className="h-3 w-3" />
                    </a>
                  )}
                </footer>
              </blockquote>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
